import { createContext } from "utils/react/createContext";

interface IDrawerContext {
  handleClose(): void;
  isOpen: boolean;
}

export const [DrawerContext, useDrawerContext] = createContext<IDrawerContext>();
